@if (isBannerThumb === true) {
    <div class="blog-slideshow-container {{ isBannerThumb }}">
        <div class="blog-slideshow">
            <div class="blog-books">
                @for (banner of bannerActual; track banner; let i = $index) {
                    <div class="blog-book">
                        <div class="blog-c">
                            <a routerLink="blog/{{ banner.routerLink }}"
                                ><img class="blog-thumb-image" [@fade] [src]="banner.thumbnailUrl"
                            /></a>
                            <div class="book-blog-title">
                                <h4>{{ banner.title }}</h4>
                            </div>
                        </div>
                    </div>
                }
                @if (bannerActual.length < 3) {
                    <div class="placeholder"></div>
                }
            </div>
        </div>
        <div class="buttons-previous-next">
            <div class="button-previous">
                <button class="previous-button"><mat-icon (click)="showPreviousImage()">keyboard_arrow_left</mat-icon></button>
            </div>
            <div class="button-next">
                <button class="next-button"><mat-icon (click)="showNextImage()">keyboard_arrow_right</mat-icon></button>
            </div>
        </div>
    </div>
}

@if (isBannerThumb === true) {
    <div class="blog-slideshow-container-mobile {{ isBannerThumb }}">
        <div class="blog-slideshow-mobile">
            <div class="blog-books-mobile">
                <div class="blog-book-mobile">
                    <a routerLink="blog/{{ bannerActualMobile?.routerLink }}"
                        ><img class="blog-thumb-image-mobile" [@fade] [src]="bannerActualMobile?.thumbnailUrl"
                    /></a>
                    <div class="book-blog-title-mobile">
                        <h4>{{ bannerActualMobile?.title }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons-previous-next-mobile">
            <div class="button-previous-mobile">
                <button class="previous-button-mobile"><mat-icon (click)="showPreviousImageMobile()">keyboard_arrow_left</mat-icon></button>
            </div>
            <div class="button-next-mobile">
                <button class="next-button-mobile"><mat-icon (click)="showNextImageMobile()">keyboard_arrow_right</mat-icon></button>
            </div>
        </div>
    </div>
}
